import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 28 28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#B20FC0",
      d: "M14 16.962a4.487 4.487 0 1 0 0-8.975 4.487 4.487 0 0 0 0 8.975ZM14 16.962a7.18 7.18 0 0 1 7.097 6.095L18 25l-4 .5-3.5-.5-3.597-1.943A7.18 7.18 0 0 1 14 16.962Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#B20FC0",
      "fill-rule": "evenodd",
      d: "M14 3.083C7.97 3.083 3.083 7.971 3.083 14c0 6.03 4.888 10.917 10.917 10.917 6.03 0 10.917-4.888 10.917-10.917S20.029 3.083 14 3.083ZM1.583 14C1.583 7.143 7.143 1.583 14 1.583c6.858 0 12.417 5.56 12.417 12.417 0 6.858-5.56 12.417-12.417 12.417-6.858 0-12.417-5.56-12.417-12.417Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "user-filled"}) } }